<template>
  <div>

    <div class="form-row">
      <div class="col-12 d-flex align-items-center flex-wrap mb-3 flex-column flex-sm-row text-center">
        <h5 class="text-blue-ml">Idiomas</h5>

        <button type="button" class="btn btn-outline-blue-ml ml-0 ml-sm-auto" @click="edit(null)">
          Adicionar Idioma
        </button>
      </div>

      <div class="col-12 mb-4" v-for="(language, index) in languages" :key="index">
        <div class="d-flex align-items-center justify-content-between justify-content-md-start">
          <div class="mr-3">
            <h5 class="mb-0">{{ language.language }}</h5>
            <p class="mb-0">{{ $store.state.domains.language_proficiencies.find(el => el.id == language.proficiency)['description'] }}</p>
          </div>

          <div class="btn-group" role="group">
            <button type="button" class="btn btn-light" @click="edit(language)"> <pencil-icon class="align-text-bottom text-blue-ml" /> </button>
            <button type="button" class="btn btn-light" @click="remove(language.id)"> <delete-icon class="align-text-bottom text-blue-ml" /> </button>
          </div>
        </div>
      </div>

    </div>

    <b-modal ref="modal-language" size="lg" centered :hide-header="true" :hide-footer="true" no-close-on-backdrop lazy>
      <div class="py-4 px-2 px-lg-4">
        <h4 class="text-blue-ml mb-4">IDIOMA</h4>

        <button type="button" class="ml-auto close" @click="$refs['modal-language'].hide()">
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <FormLanguage @closeModal="$refs['modal-language'].hide()" hasButtons />
      </div>
    </b-modal>

    <div v-if="format == 'inline-form' && (languages.length == 0 || $route.name == 'atualizacao-perfil') && ($route.name == 'deixe-seu-perfil' || $route.name == 'atualizacao-perfil')">
      <div class="form-area mb-5" :class="{ 'has-multiple': formsIds.length > 1 }" v-for="(item, index) in formsIds" :key="index">
        <FormLanguage storeByEventBus />
        <div class="d-flex" v-if="formsIds.length > 1">
          <button class="btn btn-link btn-lg p-0 ml-auto" @click="removeForm(item)"> <u>Remover Idioma</u> </button>
        </div>
      </div>

      <div class="d-flex">
        <button class="btn btn-outline-blue-ml btn-lg mx-auto" @click="addForm()">Adicionar Idioma</button>
      </div>
    </div>

  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import FormLanguage from './FormLanguage.vue';

export default {
  name: 'BoxLanguage',

  data() {
    return {
      formsIds: [new Date().getTime()],
      no_languages: true,
    };
  },

  computed: {
    languages() {
      const { user } = this.$store.state;
      if (user.profile) {
        return this.$store.state.user.profile.languageProficiencies || [];
      }
      return [];
    },
  },

  props: {
    format: {
      type: String,
      default: 'inline-form',
    },
  },

  components: {
    CloseIcon,
    PencilIcon,
    DeleteIcon,
    FormLanguage,
  },

  methods: {
    addForm() {
      this.formsIds.push(new Date().getTime());
    },

    removeForm(item) {
      this.$swal({
        title: 'Atenção',
        text: 'Tem certeza que deseja remover o Idioma?',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, desejo remover',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.formsIds = this.formsIds.filter((form) => form !== item);
        }
      });
    },

    edit(language) {
      this.$refs['modal-language'].show();
      setTimeout(() => this.$EventBus.$emit('editingLanguage', language), 100);
    },

    remove(id) {
      if (!id) return;

      this.$swal({
        title: 'Atenção',
        text: 'Tem certeza que deseja remover o Idioma?',
        type: 'error',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, desejo remover',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('user/languageDelete', { id });
        }
      });
    },
  },

};
</script>

<style lang="scss" scoped></style>
